/**
 * Website Theme Controller (Simplified)
 * Auto-detects system preference (prefers-color-scheme)
 * No toggle button - respects browser/OS settings only
 *
 * Philosophy: Simple, event-driven, single path (CLAUDE.md)
 */

(function() {
    'use strict';

    /**
     * Get theme based on system preference
     * @returns {string} 'dark' or 'light'
     */
    function getSystemTheme() {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        return 'light';
    }

    /**
     * Apply theme to document
     * @param {string} theme - 'dark' or 'light'
     */
    function applyTheme(theme) {
        document.documentElement.setAttribute('data-theme', theme);

        // Update meta theme-color for mobile browsers
        var metaThemeColor = document.querySelector('meta[name="theme-color"]');
        if (metaThemeColor) {
            // Read colors from design tokens (single source of truth)
            var rootStyles = getComputedStyle(document.documentElement);
            var themeColor = theme === 'dark'
                ? rootStyles.getPropertyValue('--ws-gray-11').trim()
                : rootStyles.getPropertyValue('--ws-white').trim();
            metaThemeColor.setAttribute('content', themeColor);
        }
    }

    /**
     * Listen to system preference changes
     */
    function listenToSystemPreference() {
        if (window.matchMedia) {
            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function(e) {
                var newTheme = e.matches ? 'dark' : 'light';
                applyTheme(newTheme);
            });
        }
    }

    // Initialize immediately (before page renders)
    var initialTheme = getSystemTheme();
    applyTheme(initialTheme);

    // Listen for system preference changes after DOM loads
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', listenToSystemPreference);
    } else {
        listenToSystemPreference();
    }

    // Expose toggle for testing via console
    window.toggleTheme = function() {
        var current = document.documentElement.getAttribute('data-theme') || 'light';
        var newTheme = current === 'dark' ? 'light' : 'dark';
        applyTheme(newTheme);
        console.log('Theme toggled to:', newTheme);
        return newTheme;
    };

})();
